import { render, staticRenderFns } from "./zLoading.vue?vue&type=template&id=6bb61635&scoped=true&"
import script from "./zLoading.vue?vue&type=script&lang=js&"
export * from "./zLoading.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bb61635",
  null
  
)

export default component.exports